import { slugs } from '@/constants/slugs'
import { useTranslate } from '@/utils/translate/translate-client'
import { createBaseConfig, createStandardTabs } from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-data/shared'

export const useHomesteadSeriesGiveawayConfig = () => {
  const { t } = useTranslate('giveaway')
  return createBaseConfig({
    backgroundVideoUrl:
      'https://content.angelstudios.com/homestead-series/homestead_tCLIP_LoopingHub_kFHD_16x9_f23_cH264_y20241226_iJH.mp4',
    theatricalSlug: slugs.homesteadSeries,
    heroTitle: t(
      'giveawayHeroTitleHomesteadSeriesV1',
      'Enter to win the Homestead Escape & Evade Giveaway worth over $85,000!',
    ),
    logoUrl:
      'https://images.angelstudios.com/image/upload/v1764192846/homestead-giveaway/updated/Homestead_Escape_Evade_final.svg',
    inTheatersText: t('newEpisodesStreamingNow', 'New Episodes Streaming Now'),

    rulesLink: 'https://certified.promotrust.com/AngelFilms/HomesteadSeriesSweepstakesEscapeandEvade/rules.pdf',

    videoImage: '/v1764117704/hq720_custom_1_mdosei.webp',

    tabs: createStandardTabs(t),

    steps: [
      {
        title: t('watchHomestead', 'Watch Homestead'),
        description: t(
          'becomeAGuildMemberAndStartStreamingHomesteadV1',
          'Become an Angel Guild Member and start streaming the Homestead movie and series.',
        ),
      },
      {
        title: t('existingGuildMembersAreEnteredToo', 'Existing Guild Members are Entered Too!'),
        description: t('worksTheSameWay', "If you're already an Angel Guild Member, it works the same way!"),
      },
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'theMoreYouWatchV1',
          'You get an entry into the giveaway for every full episode of Homestead you watch beginning November 26th- Movie, Series, Homestead: Family Survival—the more you watch, the more entries you get!',
        ),
      },
    ],

    galleryImages: [],
    partnerLogos: [],
  })
}
